window.Vue = require('vue/dist/vue.js')
import jQuery from 'jquery'
import axios from 'axios'
import lodash from 'lodash-es'
import moment from 'moment'
import 'moment/locale/fr'
import EventBus from './event-bus'
import VueRouter from 'vue-router'
import store from './stores/store'
import { mapFields } from 'vuex-map-fields'
import Cookies from 'js-cookie';
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import {
  required,
  required_if,
  email,
  digits,
  min,
  confirmed,
  oneOf,
} from 'vee-validate/dist/rules'
import { setInteractionMode } from 'vee-validate'
import i18n from './i18n.js'
import './common'
/*
 *
 */
import 'bootstrap/js/dist/collapse'
import 'bootstrap/js/dist/modal'
import '../scss/_vue2-datepicker.scss'
import 'vue2-datepicker/locale/fr'
import 'vue2-datepicker/locale/en'
import '../scss/_vue-treeselect.scss'
/*
 *
 */
let locale = document.head.querySelector('meta[name="app-locale"]').content
moment.locale(locale)

extend('oneOf', {
  ...oneOf,
  // message: 'Le champ est invalide'
})
extend('confirmed', {
  ...confirmed,
  message: i18n.t('errors.passwordMatch'),
})
extend('required_if', {
  ...required_if,
  message: i18n.t('errors.requiredFields'),
})
extend('required', {
  ...required,
  message: i18n.t('errors.requiredFields'),
})
extend('email', {
  ...email,
  message: i18n.t('errors.invalidEmail'),
})
extend('min', {
  ...min,
  message: i18n.t('errors.twoDigits'),
})
/*
 *
 */
import '../scss/blog.scss'
window.$ = window.jQuery = jQuery
let baseUrl = document.head.querySelector('meta[name="api-baseurl"]')
axios.defaults.baseURL = baseUrl.content

const token = Cookies.get('clientToken');

if (token) {
  axios.defaults.headers.common['Authorization'] = token
} else console.error(' Token not found')
/*
 *
 */
Object.defineProperty(Vue.prototype, '$axios', { value: axios })
Object.defineProperty(Vue.prototype, '$lodash', { value: lodash })
Object.defineProperty(Vue.prototype, '$moment', { value: moment })
Object.defineProperties(Vue.prototype, {
  $bus: {
    get() {
      return EventBus
    },
  },
})
Vue.use(VueRouter)

/*
 * Global Components registration
 */
Vue.component('ValidationObserver', ValidationObserver)
Vue.component('ValidationProvider', ValidationProvider)
Vue.component(
  'forgot-password-modal',
  require('./components/modals/ForgotPasswordModal.vue').default
)
Vue.component(
  'cart-modal',
  require('./components/modals/CartModal.vue').default
)
Vue.component(
  'search-modal',
  require('./components/modals/SearchModal.vue').default
)
Vue.component(
  'contact-modal',
  require('./components/modals/ContactModal.vue').default
)
Vue.component(
  'login-modal',
  require('./components/modals/LoginModal.vue').default
)
Vue.component(
  'signup-modal',
  require('./components/modals/SignupModal.vue').default
)

Vue.component(
  'login-modal',
  require('./components/modals/LoginModal.vue').default
)
Vue.component(
  'signup-modal',
  require('./components/modals/SignupModal.vue').default
)

var app = new Vue({
  el: '#app',
  store,
  i18n,
  data: {},
  computed: {
    ...mapFields(['cart', 'user']),
  },
  methods: {},
})
